/**
 * Agent Chat Job 请求参数
 */
export interface GenerateJobRequest {
    /**
     * 用户输入文本
     */
    input: string;

    /**
     * Agent ID 列表
     */
    agent_ids?: string[];

    /**
     * Team ID 列表
     */
    team_ids?: string[];
    sensitive_ignore?: boolean;
}

/**
 * Agent Chat Job 响应
 */
export interface GenerateJobResponse {
    /**
     * Job ID，用于跳转到对话页面
     */
    job_id: string;
}

/**
 * Agent API 服务接口
 * 负责与 Agent 相关的 API 交互
 */
export interface AgentApi {
    /**
     * 创建 Agent Chat Job
     *
     * @param request - 请求参数，包含 input 和 agent_ids/team_ids
     * @returns Promise<GenerateJobResponse> - 返回包含 job_id 的响应
     */
    chatJob(request: GenerateJobRequest): Promise<GenerateJobResponse>;
}

export const AgentApi = Symbol.for('AgentApi');
